/**
 * Created by prakash on 22/9/18.
 */

import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ApplicationListPageData} from "./applicationList-datatable/applicationList-page-data";
import {ApplicationListDashboard} from "./applicationList-datatable/applicationList-dashboard";
import {ApplicationListPage} from "./applicationList-datatable/applicationList-page";

/**
 * A server used to mock a paged data result from a server
 */
@Injectable()
export class ApplicationListDashboardResultService {
    listData:any;
    loginData;
    rows = {};
    applicationDashboardData = {};

    constructor(){}

    /**
     * A method that mocks a paged server response
     * @param page The selected page
     * @returns {any} An observable containing the employee data
     */
    public getResults(page: ApplicationListPage,listData): Observable<ApplicationListPageData<ApplicationListDashboard>> {
        this.listData = listData;
        return Observable.of(listData).map(data => this.getPageData(page));
    }

    /**
     * Package companyData into a PagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @returns {PagedData<icsList>} An array of the selected data and page
     */
    private getPageData(page: ApplicationListPage): ApplicationListPageData<ApplicationListDashboard> {
        let pageData = new ApplicationListPageData<ApplicationListDashboard>();
        let offset = this.listData.offset;
        let raw = [];
        for(let l in this.listData){
            if(Object.keys(this.listData[l]).length > 0){
                raw[offset+parseInt(l)] = this.listData[l];
            }
        }
        if(this.listData.totalCount){
            page.totalElements = this.listData.totalCount;
        }
        page.totalPages = page.totalElements / page.size;
        let start = page.pageNumber * page.size;
        let end = Math.min((start + page.size), page.totalElements);
        for (let i = start; i < end; i++) {
            if(raw[i]){
                let jsonObj = raw[i];
                if(jsonObj){
                    let list = new ApplicationListDashboard(jsonObj['id'], jsonObj['applicationName'], jsonObj['ldapApplicationId'],
                        jsonObj['managerNames'], jsonObj['customerNumberRequired'], jsonObj['skipManagerApproval'],
                        jsonObj['multipleRole'], jsonObj['status'], jsonObj['active'], jsonObj['createdAt']);
                    pageData.data.push(list);
                }
            }
        }
        pageData.page = page;
        return pageData;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/applicationManagement/applicationListDashboardResultService.ts